import React from "react";
import {
  NutritionsCard,
  NutritionItem,
  IconWrapper,
  TextWrapper,
  NutritionRow,
  VerticalDivider
} from "../styles";
import { Divider } from "../../../UserDashboard/styles";
import PropTypes from "prop-types";
import { CalorieIcon, CarbsIcon, FatIcon, FiberIcon, ProteinIcon, SodiumIcon, SugarIcon } from "../../../../utils/icons";
import { commaSeperator } from "../../../../utils/methods";

function RecipeNutritions({recipeDetails}) {



  if (!recipeDetails) return null;

  const nutritionData = [
    {
      label: "Protein",
      value: recipeDetails?.protein ? `${commaSeperator(recipeDetails?.protein)} g` : null,
      icon: ProteinIcon()
    },
    // {
    //   label: "Calories",
    //   value: recipeDetails?.calories
    //     ? `${recipeDetails?.calories}`
    //     : null,
    //   icon:  CalorieIcon()
    // },
    {
      label: "Carbs",
      value: recipeDetails?.carbs ? `${commaSeperator(recipeDetails?.carbs)} g` : null,
      icon:  CarbsIcon()
    },
    {
      label: "Fat",
      value: recipeDetails?.fat ? `${commaSeperator(recipeDetails?.fat)} g` : null,
      icon: FatIcon()
    },
    {
      label: "Fiber",
      value: recipeDetails?.fiber ? `${commaSeperator(recipeDetails?.fiber)} g` : null,
      icon:  FiberIcon()
    },
    {
      label: "Sugar",
      value: recipeDetails?.sugar ? `${commaSeperator(recipeDetails?.sugar)} g` : null,
      icon: SugarIcon()
    },
    {
      label: "Sodium",
      value: recipeDetails?.sodium 
        ? `${ commaSeperator(recipeDetails?.sodium)} mg`
        : null,
      icon:  SodiumIcon()
    },
  ];
  //   const nutritionData = [
  //     { label: "Protein", value: "10–12g", icon: "🥩" },
  //     { label: "Calories", value: "320 kcals", icon: "🔥" },
  //     { label: "Carbs", value: "10–12g", icon: "🍞" },
  //     { label: "Fiber", value: "10–12g", icon: "🥬" },
  //     { label: "Fat", value: "10–12g", icon: "🥑" },
  //     { label: "Sugar", value: "10–12g", icon: "🍬" }
  //   ];

  const renderRow = (rowData) =>
    rowData.map((item, index) => (
      <>
        {item.value ? <React.Fragment key={item.label}>
          <NutritionItem>
            <IconWrapper>{item?.icon}</IconWrapper>
            <TextWrapper>
              <div className="label">{item?.label}</div>
              <div className="value">{item?.value}</div>
            </TextWrapper>
          </NutritionItem>
  
          {/* Vertical divider except last item */}
          {index !== rowData.length - 1 && <VerticalDivider />}
        </React.Fragment> :null}
      </>
    ));

  return (
    <>
      <TextWrapper style={{flexDirection:'row', alignItems:'center'}}> <div className="value">Total Serving Amount</div></TextWrapper>

      <NutritionItem style={{display:'flex',margin:'12px 0px',alignItems:'center',width:'auto'}}>
        <IconWrapper>{CalorieIcon()}</IconWrapper>
        <TextWrapper style={{flexDirection:'row', alignItems:'center'}}>
          <div className="label">Calories</div>
          <div className="value">{commaSeperator(recipeDetails?.calories)} kcals</div>
        </TextWrapper>
      </NutritionItem>

      <NutritionsCard>
  
        <NutritionRow>{renderRow(nutritionData?.slice(0, 3))}</NutritionRow>
  
        <Divider  isMargin={"0px"}></Divider>
  
        <NutritionRow>{renderRow(nutritionData?.slice(3, 6))}</NutritionRow>
      </NutritionsCard>
    </>
  );
}



RecipeNutritions.propTypes = {
  recipeDetails: PropTypes.array,
 
};

export default RecipeNutritions;
